// extracted by mini-css-extract-plugin
module.exports = {"serviceDetailsContainer":"ServiceDetails_serviceDetailsContainer__Ifs6w","thumbnail":"ServiceDetails_thumbnail__1_F4y"};